import {
    Page,
    Text,
    View,
    Document,
    StyleSheet
} from "@react-pdf/renderer";
import { Font } from "@react-pdf/renderer";

Font.register({
    family: "Roboto",
    src: "/fonts/Roboto-Regular.ttf"
});

const styles = StyleSheet.create({
    page: { padding: 20, fontFamily: "Roboto" }, // ✅ apply globally
    header: { fontSize: 16, marginBottom: 10 },
    row: { flexDirection: "row" },
    cell: {
  width: "10%",   // 10 columns = 100%
  fontSize: 8,
  padding: 4,
  borderWidth: 1,
  borderColor: "#ccc"
}
});

interface OrderRow {
  orderId: number;
  clinic: string;
  type: string;
  assignedHub: string;
  assignedDesigner: string;
  partner: string;
  paymentType: string;
  paymentStatus: string;
  expectedDelivery: string;
  phone: string;
  payment: number;
  status: string;
}

interface MyPDFProps {
    data: OrderRow[];
}

const MyPDF = ({ data }: MyPDFProps) => (
    <Document>
        <Page size="A4" orientation="landscape" style={styles.page}>

            <Text style={styles.header}> Report</Text>

            {/* Header Row */}
            <View style={styles.row}>
                <Text style={styles.cell}>Order ID</Text>
                <Text style={styles.cell}>Clinic</Text>
                <Text style={styles.cell}>Type</Text>
                <Text style={styles.cell}>Hub</Text>
                <Text style={styles.cell}>Designer</Text>
                <Text style={styles.cell}>Partner</Text>
                <Text style={styles.cell}>Payment Type</Text>
                <Text style={styles.cell}>Payment Status</Text>
                <Text style={styles.cell}>Payment</Text> {/* ✅ fixed */}
                <Text style={styles.cell}>Status</Text>  {/* ✅ add this */}
            </View>
            {/* Data Rows */}
            {data && data.length > 0 ? (
                data.map((d, i) => (
                    <View style={styles.row} key={i}>
                        <View style={styles.row} key={i}>
                            <Text style={styles.cell}>{d.orderId}</Text>
                            <Text style={styles.cell}>{d.clinic}</Text>
                            <Text style={styles.cell}>{d.type}</Text>
                            <Text style={styles.cell}>{d.assignedHub}</Text>
                            <Text style={styles.cell}>{d.assignedDesigner}</Text>
                            <Text style={styles.cell}>{d.partner}</Text>
                            <Text style={styles.cell}>{d.paymentType}</Text>
                            <Text style={styles.cell}>{d.paymentStatus}</Text>
                            <Text style={styles.cell}>₹ {d.payment}</Text>
                            <Text style={styles.cell}>{d.status}</Text>
                        </View>
                    </View>
                ))
            ) : (
                <Text>No Data Available</Text>
            )}
        </Page>
    </Document>
);

export default MyPDF;